import {StrictMode} from 'react'; import {createRoot} from 'react-dom/client'; import {AuthenticatedApp} from './AuthenticatedApp'; import './styles.css'; import './functional.css';
import './dispatch-fixes.css';
import './cmms.css';
import './ppm.css';
import './cmms-role.css';
import './helpdesk.css';
import './cmms-admin.css';
import './user-admin.css';
import './attachments.css';
import './platform-admin.css';
createRoot(document.getElementById('root')!).render(<StrictMode><AuthenticatedApp/></StrictMode>);
